import React from 'react';
import {
  Button,
  ButtonDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import { IconSpan } from '../../../../../../../../components/IconSpan';
import { Icon } from '../../../../../../../../components/Icon';
import { SpanTooltip } from '../../../../../../../../components/SpanTooltip';

const HIRED_TOOLTIP_TEXT =
  'Review candidates is only available for active candidates';
const LAST_STAGE_TOOLTIP_TEXT =
  'Candidate is already at the final stage and cannot be moved further';
const ARCHIVED_JOB_TOOLTIP_TEXT =
  'Move to stage is not available for archived jobs';

interface MoveDropdownButtonProps {
  disabled: boolean;
  isLastStage: boolean;
  isHired: boolean;
  isArchivedJob: boolean;
  isDropdownOpen: boolean;
  onToggle: () => void;
  onMoveToNext: () => void;
  onMoveToSpecific: () => void;
}

export function MoveDropdownButton(props: MoveDropdownButtonProps) {
  const isMovementDisabled =
    props.disabled || props.isLastStage || props.isArchivedJob;
  const tooltipText = props.isHired
    ? HIRED_TOOLTIP_TEXT
    : props.isLastStage
    ? LAST_STAGE_TOOLTIP_TEXT
    : props.isArchivedJob
    ? ARCHIVED_JOB_TOOLTIP_TEXT
    : null;

  return (
    <ButtonDropdown
      isOpen={props.isDropdownOpen}
      toggle={props.onToggle}
      className='me-3h'
    >
      <SpanTooltip
        text={
          <Button
            color='success'
            disabled={isMovementDisabled}
            onClick={props.onMoveToNext}
            className='rounded-end-0'
          >
            <IconSpan
              icon={{ name: 'bi-arrow-return-right' }}
              spanText='Move to next Stage'
            />
          </Button>
        }
        tooltipText={tooltipText}
        showTooltip={tooltipText != null}
        placement='top'
      />
      <DropdownToggle
        color='success'
        disabled={isMovementDisabled}
        className='rounded-start-0 border-start border-light px-2'
      >
        <Icon
          name='bi-chevron-down'
          className='fs-5'
          style={{
            transition: 'transform 0.2s ease',
            transform: props.isDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            display: 'inline-block',
          }}
        />
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem
          onClick={props.onMoveToNext}
          disabled={isMovementDisabled}
        >
          <div className='fw-semibold'>Move to Next Stage</div>
          <div className='fs-6 text-muted'>
            The candidate will move to the next stage.
          </div>
        </DropdownItem>
        <DropdownItem
          onClick={props.onMoveToSpecific}
          disabled={isMovementDisabled}
        >
          <div className='fw-semibold'>Move to Specific Stage</div>
          <div className='fs-6 text-muted'>
            Select the stage to move this candidate to.
          </div>
        </DropdownItem>
      </DropdownMenu>
    </ButtonDropdown>
  );
}
